module.exports = "/_next/static/images/55175a7f1941a5fad66672b78ccd0ee9-vigilado-left.png.webp";